/**
 * Utility module, that extends client-config with default-client-config items in
 * case of their absence.
 */

import defaultClientConfigText from 'raw-loader!default-client-config';
import P from 'bluebird';
import $ from 'jquery';

/**
 * Config parse.
 *
 * @param {String} configText Config in text mode.
 * @returns {Object} Configuration object or empty object if config invalid.
 */
function parseConfig(configText) {
  try {
    // eslint-disable-next-line no-new-func
    return (new Function(`return ${configText}`))();
  }
  catch (e) {
    console.error('Bad client-config.js!', e);

    return {};
  }
}

const defaultClientConfig = parseConfig(defaultClientConfigText);

const clientConfig = $.extend(true, {
  loadD: new P((resolve, reject) => {
    return $.get('/client-config.js', {}, $.noop, 'text').done((configText) => {
      $.extend(true, clientConfig, parseConfig(configText));

      resolve();
    }).fail(() => resolve());
  }, () => {
  })
}, defaultClientConfig);

export default clientConfig;
